import { MissingPersonalDetails } from './missing-personal-details';

export default MissingPersonalDetails;
